module.exports = __webpack_public_path__ + "static/media/compressed.e65d9c0a.gif";